export default {
  SET_EMERGENCY_ROOM_DASHBOARD_DATA(state, data) {
    state.dashboardData = data
  },
  SET_EMERGENCY_ROOM_ITEMS(state, items) {
    state.items = items
  },
  SET_EMERGENCY_ROOM_TOTAL(state, total) {
    state.total = total
  },
  SET_EMERGENCY_ROOM_QUERY(state, query) {
    state.query = query
  },
  SET_EMERGENCY_ROOM_STATUS(state, status) {
    state.status = status
  },
  SET_EMERGENCY_ROOM_PAGE(state, page) {
    state.page = page
  },
  SET_EMERGENCY_ROOM_LOADING(state, loading) {
    state.loadingItems = loading
  },
  SET_EMERGENCY_ROOM_FIRST_ITEM(state, item) {
    state.firstItem = item
  }
}
